import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Table,
  Col,
} from "reactstrap";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "../reports.scss";
import { ToWords } from "to-words";

// import "../app-invoice.css";
import { getWODocReport } from "../../../store/Reports/actions";
import SLE_logo from "../../../assets/images/SriLalitha_Logo.png";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import LoadingModel from "../../LoadingModel";

class SRPOReportAMCDocument extends Component {
  constructor(props) {
    super(props);
    this.state = { amountInWords: "" };
  }

  componentDidMount() {
    this.props.getWODocReport(this.props.match.params.id, this.props.POPdf);
  }
  // getPDFReport() {
  // 	//	297 x 210 mm
  // 	const codewidth = document.getElementById("toPdf").style.width;
  // 	document.getElementById("toPdf").style.width = "297mm";
  // 	const doc = new jsPDF("l", "mm", [297, 210]);
  // 	doc.setDisplayMode(1);
  // 	doc.html(document.getElementById("toPdf"), {
  // 		callback: function (doc) {
  // 			doc.save();
  // 			document.getElementById("toPdf").style.width = codewidth;
  // 		},
  // 		x: 0,
  // 		y: 0,
  // 		html2canvas: { scale: 0.25 },
  // 	});
  // }

  getPDFReport = async () => {
    const element = document.getElementById("toPdf");
    if (!element) return;

    const originalWidth = element.style.width;
    element.style.width = "297mm";
    element.style.maxWidth = "290mm";

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    // Use a higher scale for better text clarity
    const canvas = await html2canvas(element, {
      scale: 1.5,
      useCORS: true,
      scrollX: 0,
      scrollY: 0,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight,
    });

    const imgData = canvas.toDataURL("image/png");
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position -= pageHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save("Service_Request_Purchase_Order_Report_AMC.pdf");

    // Revert back to original
    element.style.width = originalWidth;
  };
  reportBody() {
    const toWords = new ToWords();
    return (
      <Row className="p-1 report-preview">
        <Col md={12} className="p-1">
          <Card className="p-1 report-preview-card">
            <CardBody className="report-padding pb-0">
              <div className="report-body flex-sm-row flex-column  mt-0">
                <div className=" ">
                  <h5 className="card-title-16 pt-2 ">
                    SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD
                  </h5>
                  <p className="card-title-14 pt-2 mb-0">
                    Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist. - AP
                  </p>
                  <p className="card-title-14 pt-2 mb-0">
                    Phone No.0884-2326661, 62, Mobile No.9494127893,
                  </p>
                  <p className="card-title-14 pt-2 mb-0">
                    Email: purchase@sleipl.com, lalitharice@gmail.com
                  </p>
                  <p className="card-title-14 pt-2">GSTIN : 37AAKCS3233N1ZX</p>
                </div>
                <div className="pt-2">
                  <span className="p-4">
                    <img
                      className="img-fluid p-0"
                      src={SLE_logo}
                      alt="Logo"
                      width="100"
                      height="120"
                    />
                  </span>
                  <h4 className="report-title mb-0 text-center">AMC </h4>
                  <h5 className="report-title">
                    <span className="report-number">
                      #{this.props.WO_Doc_report.code}
                    </span>
                  </h5>
                </div>
              </div>
              <hr className="hr-black-color " />

              <div className="report-body flex-sm-row flex-column mt-0">
                <div>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">Vendor Name:</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.vendor?.name}
                    </p>
                  </div>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">Vendor Location:</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.vendor?.city}
                    </p>
                  </div>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">Vendor Phone:</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.vendor?.mobile}
                    </p>
                  </div>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">Vendor GST:</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.vendor?.gstno}
                    </p>
                  </div>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">RFD Code:</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.requestforquotation_code}
                    </p>
                  </div>

                  <div className="report-wrapper">
                    <p className="report-wrapper-title">Sub Location</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.sublocation?.name
                        ? this.props.WO_Doc_report.sublocation?.name
                        : ""}
                    </p>
                  </div>
                  {/* <div className="report-wrapper">
                    <p className="report-wrapper-title">Transport By</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report?.transport_by_name ? this.props.WO_Doc_report.transport_by_name : ""}
                    </p>
                  </div> */}
                </div>
                <div>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">Prepared Date:</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.createdon}
                    </p>
                  </div>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">Quotation Code:</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.quotation_code}
                    </p>
                  </div>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">Quotation Date:</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.quotation_date && (
                        <>
                          {moment(
                            this.props.WO_Doc_report.quotation_date
                          ).format("DD-MM-YYYY")}
                        </>
                      )}
                    </p>
                  </div>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">Workorder Location:</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.location?.name}
                    </p>
                  </div>

                  {/* <div className="report-wrapper">
                    <p className="report-wrapper-title">PO Type:</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.purchase_type_name}
                    </p>
                  </div>

                  <div className="report-wrapper">
                    <p className="report-wrapper-title">Cost Center Type:</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.sublocation?.cost_center_type_name ? this.props.WO_Doc_report.sublocation?.cost_center_type_name : ""}
                    </p>
                  </div> */}
                </div>
              </div>
              <hr className="hr-black-color " />
              <div className="m-0">
                <Table
                  // striped
                  bordered
                  // hover
                  className="mb-0 p-0 table-centered table-color-black"
                >
                  <thead className="bg-light text-center">
                    <tr>
                      <th style={{ width: "2%" }}>S.NO</th>
                      <th style={{ width: "13%" }}>Item Image</th>
                      <th style={{ width: "33%" }}>Item Name</th>
                      <th style={{ width: "9%" }}>Quantity / Units</th>
                      <th style={{ width: "9%" }}>Item Base Price</th>
                      <th style={{ width: "4%" }}>Item Discount(%)</th>
                      <th style={{ width: "9%" }}>
                        Item Price
                        <br />
                        <sup>(Discount)</sup>
                      </th>
                      <th style={{ width: "4%" }}>Tax Type (%)</th>
                      <th style={{ width: "8%" }}>Tax Amount</th>

                      <th style={{ width: "9%" }}>Gross Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.WO_Doc_report?.woitems?.map((item, key) => (
                      <tr key={key}>
                        <td className="text-center">{key + 1}</td>
                        <td className="nowrap text-center">
                          <div className="product-detail text-center">
                            <img
                              src={
                                item?.product.image == null
                                  ? DefaultImg
                                  : item?.product.image
                              }
                              alt="product-img"
                              title="product-img"
                              className="product-img  img-fluid mx-auto tab-img rounded"
                              style={{
                                height: "200px",
                                width: "400px",
                              }}
                            />
                          </div>
                        </td>
                        <td>
                          <h5 className="font-size-14 text-black ">
                            {item?.product?.name}
                          </h5>
                          <p className="mb-0 text-black">
                            <b>Make :</b>{" "}
                            <span className="font-weight-medium  text-black">
                              {item.make}
                            </span>
                          </p>
                          <p className="mb-0 text-black">
                            <b>Description :,</b>{" "}
                            <span className="font-weight-medium  text-black">
                              {item.description}
                            </span>
                          </p>
                          <p className="mb-0">
                            <b>Specifications :</b> <br />
                            {item.product.description !== null ? (
                              <span
                                className="font-weight-medium font-size-12"
                                dangerouslySetInnerHTML={{
                                  __html: item.product.description.replaceAll(
                                    "\n",
                                    "<br/>"
                                  ),
                                }}
                              ></span>
                            ) : (
                              <span className="font-weight-medium  font-size-12">
                                {item.product.description}
                              </span>
                            )}
                          </p>
                          <p className="mb-0 text-black">
                            <b
                              style={{
                                fontWeight: 800,
                              }}
                            >
                              Item Group :
                            </b>{" "}
                            <span
                              style={{
                                fontWeight: 800,
                              }}
                              className="font-weight-medium text-black"
                            >
                              {item.product?.group?.name}
                            </span>
                          </p>

                          {item.woi_acknowledges.length !== 0 && (
                            <>
                              <p className="mb-0">
                                <b className="text-danger">Acknowledge :</b>
                                <span className="font-weight-medium">
                                  {item.woi_acknowledges[0].description}
                                </span>
                              </p>
                              <p className="mb-0">
                                <b className="text-danger">Acknowledge By :</b>
                                <span className="font-weight-medium">
                                  {item.woi_acknowledges[0].createdby.fullname}(
                                  {item.woi_acknowledges[0].createdby.username})
                                </span>
                              </p>
                            </>
                          )}
                        </td>

                        <td className="text-center">
                          {item.qty} {item.unit?.name}
                        </td>
                        <td className="text-center">{item.baseprice}</td>
                        <td className="text-center">{item.discountpercent}%</td>
                        <td className="text-center">
                          {item.price}
                          <br />
                          <sup>({item.discount})</sup>
                        </td>
                        <td className="text-center">
                          {parseInt(item.taxtype) === 1
                            ? "Inclusive"
                            : "Exclusive"}{" "}
                          ({item.tax.name})
                        </td>

                        <td className="text-center">{item.taxamount}</td>
                        <td className="text-center">{item.gross}</td>
                      </tr>
                    ))}
                    <tr>
                      <td className="text-left font-size-18" colSpan={9}>
                        <b>Total</b>
                      </td>
                      <td className="text-center">
                        {this.props.WO_Doc_report.total}{" "}
                        {/* {this.state.amountInWords} */}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
              <hr className="hr-black-color " />
              <Row>
                <Col md={12}>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">Amount In Words :</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.total
                        ? toWords.convert(
                            parseFloat(
                              parseFloat(
                                this.props.WO_Doc_report.total
                              ).toFixed(3)
                            ),
                            { currency: true }
                          )
                        : ""}
                    </p>
                  </div>
                </Col>
              </Row>
              <hr className="hr-black-color " />

              <Row>
                <Col md={12}>
                  <span className="TnCTitle mb-1">terms and conditions</span>
                </Col>
                <Col md={6} sm={6}>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">Delivery:</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.delivery}
                    </p>
                  </div>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">Payment:</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.payment}
                    </p>
                  </div>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">P & F:</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.pnf}
                    </p>
                  </div>
                </Col>
                <Col md={6} sm={6}>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">Transport</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.transport}
                    </p>
                  </div>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">GST:</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.gstdetails}
                    </p>
                  </div>
                </Col>
              </Row>
              <hr className="hr-black-color " />
              {/* <Row>
                <Col md={12}>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">{"Advance"}</p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.advance ? "Yes" : "No"}
                    </p>
                  </div>
                </Col>
              </Row>
              <hr className="hr-black-color " />
              <Row>
                <Col md={12}>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">
                      {"Advance Percentage"}
                    </p>
                    <p className="report-wrapper-det">
                      {this.props.WO_Doc_report.advancepercentage}
                    </p>
                  </div>
                </Col>
              </Row>
              <hr className="hr-black-color " /> */}
              <Row>
                <Col md={12}>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">{"Remarks"}</p>
                    <p className="report-wrapper-det">
                      {this.props.pdfType == "internal"
                        ? this.props.WO_Doc_report.remarks
                        : this.props.WO_Doc_report.externalremarks}
                    </p>
                  </div>
                </Col>
              </Row>
              <hr className="hr-black-color " />
              <Row>
                <Col md={12}>
                  <div className="text-black">
                    <ol>
                      <li>
                        The supplier has to file the GST returns regularly and
                        ensure compliance to GST rules and regulations in
                        respect of supply
                      </li>
                      <li>
                        if we are denied ITC owing to your non-compliance, then
                        we will recover the ITC amount along with interest,
                        penalty etc. from your pending paymetns.
                      </li>
                    </ol>
                    <p style={{ textIndent: "30px" }}>
                      Applicable TDS will be deducted under prescribed section
                      at the prescribed rate as per Income Tax Act,1961
                    </p>
                  </div>
                </Col>
              </Row>
              <hr className="hr-black-color " />
              <Row>
                <Col md={6}>
                  <p className="text-black">
                    Thanking you,
                    <br /> Yours Faithfully
                    <br />
                    For SRI LALITHA ENTERPRISES INDUSTRIES PVT LTD.
                  </p>
                </Col>
                <Col md={6}>
                  <div className="float-right">
                    <div className="report-wrapper">
                      <p className="report-wrapper-title">Prepared by:</p>
                      <p className="report-wrapper-det">
                        {this.props.WO_Doc_report.createdby && (
                          <>
                            {this.props.WO_Doc_report.createdby?.fullname} (
                            {this.props.WO_Doc_report.createdby?.username})
                          </>
                        )}
                      </p>
                    </div>
                  </div>
                </Col>
                <Col md={12} className="mt-4">
                  <spam className="mb-4 text-black">
                    <b>Managing Director</b>
                  </spam>
                </Col>
              </Row>
              <hr className="hr-black-color printme " />
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}
            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom no-print ">
                    <Link
                      to="#"
                      onClick={() => this.props.history.goBack()}
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    {/* {this.props.POPdf ? (
                      <Link
                        to={"/PurchaseOrder/" + this.props.match.params.id}
                        
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>
                    ) : (
                      <Link
                        to="/poreport"
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>
                    )} */}

                    <div className="float-right">
                      <div className="d-inline-block ">
                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" mr-2"
                          onClick={() => this.getPDFReport()}
                        >
                          <i className="ri-file-excel-2-line"></i>
                          <span className="d-none d-inline-block ml-1">
                            PDF
                          </span>
                        </Button>

                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" mr-2"
                          onClick={() => window.print()}
                        >
                          <i className="mdi  mdi-printer"></i>
                          <span className="d-none d-inline-block ml-1">
                            Print
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-1 mr-auto mx-auto" id="toPdf">
                    {this.reportBody()}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { WO_Doc_report, POPdf, loading, pdfType } = state.reports;
  return {
    WO_Doc_report,
    POPdf,
    loading,
    pdfType,
  };
};

export default connect(mapStatetoProps, {
  getWODocReport,
})(SRPOReportAMCDocument);
